// extracted by mini-css-extract-plugin
export default {"wrapper":"yandex-map_wrapper__cEj7A"};